import { render, staticRenderFns } from "./MenuPermission.vue?vue&type=template&id=0fe92689"
import script from "./MenuPermission.vue?vue&type=script&lang=js"
export * from "./MenuPermission.vue?vue&type=script&lang=js"
import style0 from "./MenuPermission.vue?vue&type=style&index=0&id=0fe92689&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports